import { ContentIcon } from "@dropbox/dash-component-library";
import { UIIcon } from "@dropbox/dig-icons";
import { CreateStackLine } from "@dropbox/dig-icons/assets";
import type { typeahead } from "@mirage/service-typeahead-search/service/types";
import { stripStringOfPotentialFilterBindings } from "@mirage/shared/search/search-filters";
import i18n from "@mirage/translations";
import { BaseResultRow, BaseResultSplitIconTitle } from "./BaseResultRow";

export const OrganizeUserQueryResultRow = (props: {
  scoredResult: typeahead.ScoredOrganizeUserQuery;
  isSelected: boolean;
}) => {
  const {
    scoredResult: {
      result: { query },
    },
  } = props;
  const title = i18n.t("omnibox_title_organize_dash_null_state");
  const queryToDisplay = query?.length
    ? stripStringOfPotentialFilterBindings(query)
    : null;

  return (
    <BaseResultRow
      icon={
        <ContentIcon
          icon={
            <UIIcon
              src={CreateStackLine}
              color={"var(--dig-color__text__base)"}
            />
          }
          size="medium"
          hasBackground={false}
        />
      }
      richTitle={
        <BaseResultSplitIconTitle
          title={title}
          itemTitle={queryToDisplay ?? undefined}
          highlightItemTitle
        />
      }
    />
  );
};
